<template>
  <!--
    Used to create a sound
  -->
  <div class="soundsAdd">
    <form>
      <div class="form-group">
        <h4 class="m-0 mt-3">
          {{ $t('soundAddComponent.sound') }}
        </h4>
        <hr class="m-0 mb-3">
        <label>{{ $t('name') }}</label>
        <input
          v-model="soundElement.name"
          v-focus
          :class="['form-control', { 'is-invalid': $validator.errors.has('Name') }]"
          type="text"
        >
        <hr class="m-0 mb-3">
        <label>{{ $t('description') }}</label>
        <input
          v-model="soundElement.description"
          v-focus
          :class="['form-control', { 'is-invalid': $validator.errors.has('Description') }]"
          type="text"
        >
        <hr class="m-0 mb-3">
        <label>{{ $t('soundAddComponent.soundFile') }}</label>
        <div class="input-group mb-3">
          <input
            ref="fileInput"
            type="file"
            accept="audio/mpeg"  
            class="form-control cursor-pointer rounded"
            @change="getFileFromInput($event)"
          >
        </div>
        <div
          v-if="uploadPercentage > 0"
          class="input-group mb-3"
        >
          <div class="input-prepend mr-3">
            <label style="width:50px;">{{ $t('staticResourceUploaderComponent.progress') }}</label>
          </div>
          <div class="progress">
            <div
              :aria-valuenow="uploadPercentage"
              :style="`width:${ uploadPercentage }%;`"
              class="progress-bar"
              role="progressbar"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ uploadPercentage }} %
            </div>
          </div>
        </div>
        <span
          v-show="errors.has('Name')" 
          class="badge badge-danger"
        >{{ errors.first('Name') }}</span>
      </div>
      <button 
        class="btn btn-primary float-right" 
        :disabled="!file || !soundElement.name"
        @click.prevent="addAndUploadSound()"
      >
        <font-awesome-icon
          class="mr-2"
          icon="check"
        />{{ $t('add') }}
      </button>
      <div class="clearfix" />
    </form>
  </div>
</template>

<script>
import { errorMixin } from '@/mixins/errorMixin.js';

export default {
  name: "SoundsAdd",
  mixins: [
    errorMixin
  ],
  data () {
    return {
      soundElement: {},
      file: null,
      fileName: null,
      uploadPercentage: null,
      uploadingRightNow: false
    }
  },
  methods: {
    async addSound () {
        let postObject = {
            'name': this.soundElement.name,
            'sourceName': this.fileName,
            'description': this.soundElement.description
        }
      await this.axios.post(`/VideoPostProcessing/AddSoundElement`, postObject)
        .then((response) => {
          //this.$emit("reload");
          this.soundElement.id = response.data; //TO BE TESTED
          this.error_clear();
        })
        .catch((error) => {
          this.error_clear();
          this.error_validate(error);
        });
    },
    async uploadSound () {
      this.uploadingRightNow = true;
      this.uploadPercentage = 0;
      let bodyFormData = new FormData();
      bodyFormData.append('formFile', this.file);
      await this.axios.post(`/VideoPostProcessingResource/UploadSound/${this.soundElement.id}`, 
        bodyFormData,
        { headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: function ( progressEvent ) {
            this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
          }.bind(this)
        }
      )
      .then((response) => {
        if (response && response.status && response.status == 200) {
          this.$emit("reload");
          this.$snotify.success(this.$t('staticResourceUploaderComponent.fileSavedMessage'));
        }
      })
      .finally(() => {
        this.uploadingRightNow = false;
        setTimeout(() => {
          this.uploadPercentage = 0;
        }, 2500);
      });
    },
    async addAndUploadSound (){
      await this.addSound();
      await this.uploadSound();
    },
    getFileFromInput () {
      this.file = this.$refs.fileInput.files[0];
      this.fileName = this.$refs.fileInput.files[0].name;
      this.uploadPercentage = 0;
    }
  }
}
</script>
<style scoped>
.soundsAdd .progress {
  display: flex;
  flex: 1 1 auto;
  width: 1%;
  height: 20px;
  font-size: 1rem;
}
</style>